
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Site Internet pas cher : pourquoi est-ce possible chez ALEO ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Cet article vous explique pourquoi créer un site Internet et pourquoi c’est désormais possible à moindre coût.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Site Internet pas cher : pourquoi est-ce possible chez ALEO ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique pourquoi créer un site Internet et pourquoi c’est désormais possible à moindre coût.",
        },
      ],
    };
  },
};
